import React from 'react';
import { Button, PasswordInput, TextInput } from '@mantine/core';
import classes from './login-page.module.scss';
import { useLoginPageController } from './useLoginPageController';

// Summary: Image-spec login screen.
// Details: docs/function-library/web/contexts-pages.md#pages-loginpage-loginpage
// inputs, primary submit button, and a brand footer. Touches:
//   - useLogin (hook) to call login.service.ts -> backend POST /login
//   - GlobalProvider (MantineProvider must wrap this tree)
//   - login-page.module.scss + theme tokens (any token change re-themes)
// Breaking change risk: removing username/password fields breaks the backend
// LoginDto contract; renaming className keys breaks login-page.module.scss.d.ts
// generated types and any test selecting by class.
export const LoginPage: React.FC = () => {
    const { form, validationErrors, isLoading, error, onSubmit, onChangeUsername, onChangePassword } = useLoginPageController();

    return (
        <div className={classes.container}>
            <div className={classes.card}>
                <div className={classes.logoWrap}>
                    <img src="/logo.png" alt="לוגו" className={classes.logo} />
                </div>

                <form className={classes.form} onSubmit={onSubmit} noValidate>
                    <TextInput
                        label="שם משתמש"
                        placeholder="שם משתמש"
                        value={form.username}
                        onChange={(e) => onChangeUsername(e.currentTarget.value)}
                        autoComplete="username"
                        size="md"
                        radius="md"
                        error={validationErrors.username}
                        required
                        data-testid="login-username"
                    />
                    <PasswordInput
                        label="סיסמה"
                        placeholder="סיסמה"
                        value={form.password}
                        onChange={(e) => onChangePassword(e.currentTarget.value)}
                        autoComplete="current-password"
                        size="md"
                        radius="md"
                        error={validationErrors.password}
                        required
                        data-testid="login-password"
                    />

                    {error && <p className={classes.error}>{error}</p>}

                    <Button
                        type="submit"
                        loading={isLoading}
                        fullWidth
                        size="lg"
                        radius="xl"
                        color="dark"
                        data-testid="login-submit"
                    >
                        התחבר
                    </Button>
                </form>

                <div className={classes.footer}>
                    Powered by <span className={classes.footerAccent}>CommunicateAI</span>
                </div>
            </div>
        </div>
    );
};
